import React, { useState, useContext } from "react";
import { Modal, Input, message } from "antd";
import axios from "axios";
import { API_DOMAIN } from "../constants";
import { AuthContext } from "../contexts/AuthContext";

export function CancelModal({ open, queryPk, queryId, onClose, onSuccess }) {
  const { authState } = useContext(AuthContext);
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);

  const handleClose = () => {
    setReason("");
    onClose();
  };

  const handleOk = async () => {
    if (!reason.trim()) { message.warning("Cancellation reason is required"); return; }
    setSaving(true);
    try {
      const res = await axios.post(
        `${API_DOMAIN}/queries/${queryPk}/cancel`,
        { userId: authState?.id, reason: reason.trim() },
        { headers: { accessToken: localStorage.getItem("accessToken") } }
      );
      if (!res.data?.success) throw new Error(res.data?.message);
      message.success("Task cancelled");
      onSuccess?.();
      handleClose();
    } catch (e) {
      message.error(e?.response?.data?.message || e.message || "Failed to cancel task");
    } finally { setSaving(false); }
  };

  return (
    <Modal
      open={open}
      title={`Cancel Task${queryId ? ` — #${queryId}` : ""}`}
      onCancel={handleClose}
      onOk={handleOk}
      confirmLoading={saving}
      okText="Cancel Task"
      okButtonProps={{ danger: true }}
      cancelText="Go Back"
      destroyOnClose
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 16 }}>
        <div style={{ fontSize: 13, color: "#595959" }}>
          This will permanently cancel the task. Please provide a reason.
        </div>
        <div>
          <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 6, color: "#595959" }}>
            Reason <span style={{ color: "#ff4d4f" }}>*</span>
          </div>
          <Input.TextArea
            rows={3}
            placeholder="e.g. Customer cancelled the order"
            value={reason}
            onChange={e => setReason(e.target.value)}
            autoFocus
          />
        </div>
      </div>
    </Modal>
  );
}
